<div class="container-fluid py-3">
  <div class="row">
    <div class="col-12">
      <p-table #dt
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} entradas"
        [filterDelay]="0"
        [loading]="sosLogService.loading"
        [paginator]="true"
        [rows]="10"
        [rowHover]="true"
        [rowsPerPageOptions]="[10, 25, 50]"
        [showCurrentPageReport]="true"
        [value]="sosLogService.sosLogs">

        <ng-template pTemplate="caption">
          <div class="container-fluid">
            <div class="row">

              <div class="col-12 d-flex align-items-center">
                Registros de botón de emergencia
              </div>

            </div>
          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="streetBuilding.name">
              Calle
              <p-sortIcon field="streetBuilding.name"></p-sortIcon>
              <p-columnFilter type="date" field="streetBuilding.name" display="menu"></p-columnFilter>
            </th>

            <th pSortableColumn="houseFlat.number">
              Número
              <p-sortIcon field="houseFlat.number"></p-sortIcon>
              <p-columnFilter type="date" field="houseFlat.number" display="menu"></p-columnFilter>
            </th>

            <th>Fecha</th>

            <th>Usuario</th>

          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-sos>
          <tr class="p-selectable-row">
            <td>
              <span class="p-column-title">Calle</span>
              {{ sos.streetBuilding.name }}
            </td>
            <td>
              <span class="p-column-title">Número</span>
              {{ sos.houseFlat.number }}
            </td>
            <td>
              <span class="p-column-title">Fecha</span>
              {{ sos.createdAt | dateToMoment: 'ddd DD MMM yyyy HH:mm' : neighborhoodService.currentNeighborhood?.timeZone }}
            </td>
            <td>
              <span class="p-column-title">Usuario</span>
              {{ sos.createdBy.email != "" ? sos.createdBy.email : sos.createdBy.username }} ({{ sos.createdBy.fullName }}) 
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
